class ColorService {
  getColorFromString(string: string, s: number, l: number): string {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      // biome-ignore lint/suspicious/noBitwiseOperators: Needed to generate random colors
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = Math.abs(hash % 360);

    return `hsl(${h}, ${s}%, ${l}%)`;
  }
}

export default new ColorService();
